interface LoggedOutFooterParams {
  className: string
}

export const LoggedOutFooter: React.FC<LoggedOutFooterParams> = ({ className }) => (
  <footer className="">
    <div className={className}>
      <div className="flex h-16 items-center justify-between text-xs text-gray-500">
        © Copyright {new Date().getFullYear()} All Rights Reserved
      </div>
    </div>
  </footer>
)
